export default __webpack_public_path__ + "static/media/Stefano Benni.8300946b.jpg";